import service from './request'

/**
 * 获取工单处理人预配置列表信息
 */
 export const perHandleManCfgGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/perHandleManCfg/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加工单处理人预配置信息
 */
 export const perHandleManCfgAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/perHandleManCfg/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改工单处理人预配置信息
 */
 export const perHandleManCfgUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/perHandleManCfg/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除工单处理人预配置信息
 */
 export const perHandleManCfgDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/perHandleManCfg/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单处理人预配置信息
 */
 export const perHandleManCfgGetInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/perHandleManCfg/getInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单处理人预配置信息
 */
 export const perHandleManCfgGetCfgInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/perHandleManCfg/getCfgInfo',
      method: 'post',
      type: 'body',
      data
  })
}


// WEBPACK FOOTER //
// ./src/http/perHandleManCfg.js